import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { ConfigsLoaderService } from '../config-loader.service';
import { AssignedTeamItem, Item } from 'app/models/item.inferface';
import { ISuggestService } from 'app/shared/components/suggest-input/model/ISuggestService';
import { TypeOfGroup } from 'app/enums/types-groups.enum';

export interface UserRoleItem extends Item {
  roles: Item[];
}

@Injectable({
  providedIn: 'root'
})
export class ConsultantByDescriptionSuggestService implements ISuggestService<Item> {

  private apiEndpoint = '';
  headers = new HttpHeaders().append('Content-Disposition', 'multipart/form-data');

  constructor(
    private httpClient: HttpClient,
    private config: ConfigsLoaderService,
  ) {
    this.apiEndpoint = this.config.apiUrl;
  }

  getSuggestByDescription(description: string): Observable<Item[]> {
    const params = new HttpParams()
      .append('description', description)
      .append('typeOfGroup', TypeOfGroup.Consultants);

    return this.httpClient.get<Item[]>(`${this.apiEndpoint}/Workflow/GetUsers`, {params})
      .pipe(
        map(response => {
          return response;
        }),
      );
  }

  getTeamSuggestByDescription(description: string): Observable<AssignedTeamItem[]> {
    const params = new HttpParams()
      .append('description', description);

    return this.httpClient.get<AssignedTeamItem[]>(`${this.apiEndpoint}/Workflow/GetUserAndUserGroup`, {params})
      .pipe(
        map(response => {
          return response;
        }),
      );
  }

  getTeamById(ids: number[], userType: number): Observable<AssignedTeamItem[]> {
    return this.httpClient.post<AssignedTeamItem[]>(`${this.apiEndpoint}/Workflow/GetUserAndUserGroupByIds`, {ids, userType})
      .pipe(
        map(response => {
          return response;
        }),
      );
  }
}


